<template>
  <div class="content if-profile">
    <div class="md-layout if-profile-body">
      <SPIFProfileHeader  :headerData="this.headerData"/>

      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0">
        <div class="md-layout">
          <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0">
            <md-card class="m-0">
              <div class="md-layout md-card if_card">
                <div class="md-layout-item md-medium-size-100 frm-tb md-size-100 p-0">
                  <md-card-header class="md-card-header md-card-header-icon">
                    Your Industry Peer Group
                  </md-card-header>
                  <md-card-content>
                    <div class="md-layout px-4">
                      <div class="md-layout-item md-medium-size-100 md-size-50">
                        <!-- <h5 class="title text-left">Firms Analyzed</h5> -->
                        <table-card class="md_table">
                          <template slot="header" header-color="rose">
                            <!--<div class="card-icon">
                            <md-icon>addchart</md-icon>
                          </div>-->
                            <h4 class="title m-0">
                              <div
                                class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                              >
                                Firms Analyzed
                              </div>
                            </h4>
                          </template>

                          <template slot="content">
                            <div class="md-layout">
                              <div class="md-layout-item md-size-100 p-0">
                                <md-table v-model="tableDataFirmsAnalyzed">
                                  <md-table-row
                                    slot="md-table-row"
                                    slot-scope="{ item }"
                                  >
                                    <md-table-cell
                                      md-label="Profile Year"
                                      md-sort-by="year"
                                    >
                                      {{ item.year }}
                                    </md-table-cell>
                                    <md-table-cell md-label="Firms">
                                      {{ item.firms }}
                                    </md-table-cell>
                                  </md-table-row>
                                </md-table>
                              </div>
                            </div>
                          </template>
                        </table-card>
                      </div>
                      <div class="md-layout-item md-medium-size-100 md-size-50">
                        <chart-card
                          header-animation="false"
                          :chart-data="colouredLineChart.data"
                          :chart-options="colouredLineChart.options"
                          chart-type="Bar"
                          header-icon
                          chart-inside-content
                          no-footer
                          background-color="blue"
                        >
                          <!--<template slot="chartInsideHeader">
                          <div class="card-icon">
                            <md-icon>timeline</md-icon>
                          </div>
                          <h4 class="title">
                            Firms Analyzed
                          </h4>
                        </template>-->
                        </chart-card>
                      </div>
                    </div>
                  </md-card-content>
                </div>
              </div>
              <div class="negetive_margin">
                <div class="md-layout">
                  <div class="md-layout-item md-medium-size-100 md-size-50">
                    <profile-card header-color="blue" class="text-card if_card">
                      <template slot="header"
                        >Your Industry In Context: The NAICS Classification
                        System</template
                      >
                      <template slot="content">
                        <div class="extra_space">
                          <p>
                            The industry your selected fits within the official
                            NAICS (North American Industry Classification
                            System) and Bizminer’s proprietary taxonomy, which
                            breaks out more detailed industries classifications
                            than NAICS by adding up to eight decimal digits
                            after the NAICS-6 code. The industry you selected
                            fits into this industry hierarchy:
                          </p>

                          <ul>
                            <li
                              v-for="(value, key) in naicsDrilldown"
                              :key="key"
                            >
                              NAICS: {{ key }} - {{ value }}
                            </li>
                          </ul>
                        </div>
                      </template>
                    </profile-card>
                  </div>
                  <div class="md-layout-item md-medium-size-100 md-size-50">
                    <profile-card header-color="blue" class="text-card if_card">
                      <template slot="header">Ratio Categories</template>
                      <template slot="content">
                        <div class="extra_space">
                          <p>
                            The Bizminer Industry Financial Priofile is based on
                            selected financial ratios that are typically
                            considered to be Key Performance Indicators (KPIs)
                            which includes:
                          </p>
                          <ul>
                            <li>
                              Cash Flow/Solvency:
                              <p>
                                Cash Flow ratios indicate a company’s ability to
                                meet various levels of demand on cash and easily
                                obtainable cash resources against current and
                                anticipated near-term payments due.
                              </p>
                            </li>
                            <li>
                              Profitability:
                              <p>
                                Profitability ratios compare levels of return
                                against various expense and balance sheet
                                components to measure your performance against
                                reasonable industry peer group standards,
                                indicating bottom line performance.
                              </p>
                            </li>
                            <li>
                              Efficiency:
                              <p>
                                Efficiency ratios measure your success in
                                marshalling resources at hand to effectively
                                manage various components of your business
                                operations. These indicators often point most
                                specifically toward actions that could enhance
                                your bottom line.
                              </p>
                            </li>
                            <li>
                              Debt-Risk:
                              <p>
                                Debt-Risk ratios assess the appropriateness of a
                                firm’s level of debt against the ability to pay,
                                as well as the risk of insolvency.
                              </p>
                            </li>
                            
                          </ul>
                        </div>
                      </template>
                    </profile-card>
                  </div>
                </div>
              </div>
            </md-card>
          </div>
        </div>
      </div>
    </div>

    <!--
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <div class="navbar md-toolbar md-transparent md-elevation-4">
        <div class="md-toolbar-section-start">
          <h1 class="md-title profile-title">Introduction</h1>
        </div>
      </div>
    </div>-->
  </div>
</template>

<script>
import { ChartCard, TableCard, ProfileCard } from '@/components';
import { mapState } from 'vuex';
import formatData from '@/mixins/format-data';
import SPIFProfileHeader from './_partials/SPIFProfileHeader.vue';

export default {
  components: {
    ChartCard,
    TableCard,
    ProfileCard,
    SPIFProfileHeader,
  },
  mixins: [formatData],
  props: ['headerData'],
  data() {
    return {
      colouredLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          // lineSmooth: this.$Chartist.Interpolation.cardinal({
          //   tension: 10,
          // }),
          axisY: {
            showGrid: true,
            offset: 40,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: '300px',
        },
      },
      tableDataFirmsAnalyzed: [],
      loading: false,
      naicsDrilldown: {},
      filtered_years: [],
      filtered_firms: [],
      filtered_PLDollar: [],
      filtered_PLPercent: [],
      filtered_BSDollar: [],
      filtered_BSPercent: [],
      cashflow: [],
      cashFlowFilteredData: [],
      efficiency: [],
      efficiencyFilteredData: [],
      profitability: [],
      profitabilityFilteredData: [],
      turnover: [],
      debtRiskFilteredData: [],
      changein: [],
      changeinFilteredData: [],
      worksheet: [],
      worksheetFilteredData: [],
      sales_class_csv: '',
    };
  },
  computed: {
    ...mapState({
      spif: (state) => state.user.profile.spif,
      data: (state) => state.user.profile.data,
      profile: (state) => state.user.profile,
      PLtable: (state) =>
        state.user.profile.tables
          ? state.user.profile.tables['PL']
          : state.user.profile.data.tables['PL'],
      BStable: (state) =>
        state.user.profile.tables
          ? state.user.profile.tables['BS']
          : state.user.profile.data.tables['BS'],
      tables: (state) =>
        state.user.profile.tables
          ? state.user.profile.tables['ratios']
          : state.user.profile.data.tables['ratios'],
      tablesInfo: (state) =>
        state.user.profile.tables
          ? state.user.profile.tables['ratioInfo']
          : state.user.profile.data.tables['ratioInfo'],
      sourcesUses: (state) =>
        state.user.profile['sourcesUses']
          ? state.user.profile['sourcesUses']
          : state.user.profile.data['sourcesUses'],
      sourceYears: (state) =>
        state.user.profile['sourcesUses']
          ? state.user.profile['sourcesUses']['years']
          : state.user.profile.data['sourcesUses']['years'],
      release_display: (state) =>
        state.user.profile.data.data.data[0].release_display,
      bznaics_code: (state) => state.user.profile.data.data.data[0].bznaics,
      sector_name: (state) =>
        state.user.profile.data.data.data[0]
          ? state.user.profile.data.data.data[0].sector
          : '',
      industry_title: (state) =>
        state.user.profile.data.data.data[0]
          ? state.user.profile.data.data.data[0].industry
          : '',
      sales_class: (state) =>
        state.user.profile.data.data.data[0]
          ? state.user.profile.data.data.data[0].sales_class
          : '',
      display_area: (state) =>
        state.user.profile.data.data.data[0]
          ? state.user.profile.data.data.data[0].display_area
          : '',
    }),
    sourceTablesInfo() {
      return _.omit(this.sourcesUses, 'years');
    },
    filteredProfile() {
      return Object.values(this.profile.data.data.data).filter((item) => item);
    },
    getCsvData() {
      let csvData = [
        ['Industry Financial Report'],
        ['"Release Date"', this.release_display],
        [''],
        ['Segment', 'Industry'],
        [this.industry_title],
        ['[' + parseInt(this.bznaics_code) + ']' + ' Sector', this.sector_name],
        ['Market', this.display_area],
        ['Sales Class', this.sales_class_csv],
        [''],
      ];
      csvData.push(['Firms Analyzed', this.filtered_years]);
      csvData.push(['', this.filtered_firms]);
      csvData.push(['']);
      csvData.push(['Income and Expense - Profit and Loss($)']);
      csvData.push(['', this.filtered_years]);
      this.filtered_PLDollar.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['Income and Expense - Profit and Loss(%)']);
      csvData.push(['', this.filtered_years]);
      this.filtered_PLPercent.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['Balance Sheet($)']);
      csvData.push(['Assets', this.filtered_years]);
      this.filtered_BSDollar.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['Balance Sheet(%)']);
      csvData.push(['Assets', this.filtered_years]);
      this.filtered_BSPercent.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['Financial Ratios: Cash Flow-Solvency']);
      csvData.push(['', this.filtered_years]);
      this.cashFlowFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['Financial Ratios: Profitability']);
      csvData.push(['', this.filtered_years]);
      this.profitabilityFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['Financial Ratios: Efficiency']);
      csvData.push(['', this.filtered_years]);
      this.efficiencyFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['Financial Ratios: Debt-Risk']);
      csvData.push(['', this.filtered_years]);
      this.debtRiskFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['Sources & Uses of Funds']);
      csvData.push(['', this.sourceYears]);
      this.changeinFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['Worksheet:']);
      this.worksheetFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      return csvData;
    },
    filteredData() {
      return Object.values(this.data).filter((item) => item);
    },
    actualData() {
      return this.filteredData[0]['cashflow'];
    },
  },
  mounted() {
    this.data.years.forEach((e, i) => {
      this.filtered_years.push(Number(e));
    });
    this.init();
    let firmData = Object.values(this.data)
      .filter((item) => item)
      .map((item) => ({ ...item, firms: item.firms }));
    firmData.forEach((element) => {
      this.filtered_firms.push(parseFloat(element.firms));
    });

    let PLdollar = this.formatTable(this.PLtable, 'industry', 'dollar');
    let PLpercent = this.formatTable(this.PLtable, 'industry', 'percent');

    PLdollar.forEach((element) => {
      if (element.name.includes(',')) {
        element.name = element.name.replace(/,/g, '');
      }
      let k = Object.values(element.dates);
      let v = [];
      k.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = parseFloat(e.replace(/,/g, ''));
        }
        v.push(e);
      });
      v.unshift(element.name);
      this.filtered_PLDollar.push(v);
    });
    PLpercent.forEach((element) => {
      if (element.name.includes(',')) {
        element.name = element.name.replace(/,/g, '');
      }
      let z = Object.values(element.dates);
      let v = [];
      z.forEach((item, i) => {
        if (typeof item === 'string' && item.includes(',')) {
          item = parseFloat(item.replace(/,/g, ''));
        }
        v.push(item);
      });
      v.unshift(element.name);
      this.filtered_PLPercent.push(v);
    });

    let BSdollar = this.formatTable(this.BStable, 'industry', 'dollar');
    let BSpercent = this.formatTable(this.BStable, 'industry', 'percent');

    BSdollar.forEach((element) => {
      let k = Object.values(element.dates);
      let v = [];
      k.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = parseFloat(e.replace(/,/g, ''));
        }
        v.push(e);
      });

      v.unshift(element.name);
      this.filtered_BSDollar.push(v);
    });
    BSpercent.forEach((element) => {
      let z = Object.values(element.dates);
      let v = [];
      z.forEach((item, i) => {
        if (typeof item === 'string' && item.includes(',')) {
          item = parseFloat(item.replace(/,/g, ''));
        }
        v.push(item);
      });
      v.unshift(element.name);
      this.filtered_BSPercent.push(v);
    });

    let cashFlowData = [];
    this.cashflow.forEach((element, index) => {
      if (element.name in this.tables['cashflow']) {
        cashFlowData.push({
          dates: element.dates,
          title: this.tablesInfo[element.name]['title'],
        });
      }
    });
    cashFlowData.forEach((element) => {
      let k = Object.values(element.dates);
      let v = [];
      k.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = parseFloat(e.replace(/,/g, ''));
        }
        v.push(e);
      });

      v.unshift(element.title);
      this.cashFlowFilteredData.push(v);
    });

    let efficiencyData = [];
    this.efficiency.forEach((element, index) => {
      if (element.name in this.tables['efficiency']) {
        efficiencyData.push({
          dates: element.dates,
          title: this.tablesInfo[element.name]['title'],
        });
      }
    });
    efficiencyData.forEach((element) => {
      let k = Object.values(element.dates);
      let v = [];
      k.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = parseFloat(e.replace(/,/g, ''));
        }
        v.push(e);
      });

      v.unshift(element.title);
      this.efficiencyFilteredData.push(v);
    });

    let profitabilityData = [];
    this.profitability.forEach((element, index) => {
      if (element.name in this.tables['profitability']) {
        profitabilityData.push({
          dates: element.dates,
          title: this.tablesInfo[element.name]['title'],
        });
      }
    });
    profitabilityData.forEach((element) => {
      let k = Object.values(element.dates);
      let v = [];
      k.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = parseFloat(e.replace(/,/g, ''));
        }
        v.push(e);
      });

      v.unshift(element.title);
      this.profitabilityFilteredData.push(v);
    });

    let debtRiskData = [];
    this.turnover.forEach((element, index) => {
      if (element.name in this.tables['turnover']) {
        debtRiskData.push({
          dates: element.dates,
          title: this.tablesInfo[element.name]['title'],
        });
      }
    });
    debtRiskData.forEach((element) => {
      let k = Object.values(element.dates);
      let v = [];
      k.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = parseFloat(e.replace(/,/g, ''));
        }
        v.push(e);
      });

      v.unshift(element.title);
      this.debtRiskFilteredData.push(v);
    });

    Object.entries(this.sourceTablesInfo).forEach(([table, data]) =>
      this.$set(this, table, this.formatSourcesData(table, data))
    );

    this.changein.forEach((element, index) => {
      let k = [];
      Object.values(element.dates).forEach((e, index) => {
        k.push(e);
      });
      k.unshift(element.title);
      this.changeinFilteredData.push(k);
    });
    this.worksheet.forEach((element, index) => {
      let k = [];
      Object.values(element.dates).forEach((e, index) => {
        k.push(e);
      });
      k.unshift(element.title);
      this.worksheetFilteredData.push(k);
    });
  },
  methods: {
    init() {
      this.tableDataFirmsAnalyzed = Object.values(this.profile.data.data.data)
        .filter((item) => item)
        .map((item) => ({ ...item, firms: this.numberWithCommas(item.firms) }));
      this.tableDataFirmsAnalyzed = _.orderBy(
        this.tableDataFirmsAnalyzed,
        ['year'],
        ['asc']
      );

      this.naicsDrilldown = this.profile.data.naicsDrilldown;
      this.colouredLineChart.data = {
        labels: this.profile.data.years,
        series: [this.filteredProfile.map((item) => item.firms)],
      };
    },
    numberWithCommas(x) {
      if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      } else {
        return x;
      }
    },
    downloadCSVData() {
      let csv = '';
      this.getCsvData.forEach((row) => {
        csv += row.join(',');
        csv += '\n';
      });
      const anchor = document.createElement('a');
      anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
      anchor.target = '_blank';
      anchor.download = 'Industry Financial Profile.csv';
      anchor.click();
    },
    formatSourcesData(table, data) {
      let getDates = (id) =>
        this.sourceYears.reduce((acc, cur, index) => {
          let value = this.actualData[this.sourceYears.length - index - 1][id];

          value = isNaN(Number(value)) ? value : Number(value.toFixed(0));

          return { ...acc, [cur]: value };
        }, {});

      return data.map((item) => ({
        ...item,
        dates: getDates(item.id),
      }));
    },
  },
};
</script>
<style lang="scss">
.introduction-body {
  display: flex;
  align-items: flex-start;
}

.introduction-title {
  display: flex;
  flex-direction: column;
  justify-content: end;
}

.loading {
  position: absolute;
  left: 45%;
  // left: calc(45% / 2);
}
</style>
